import { Injectable, inject } from '@angular/core';
import {
  CartItem,
  IsniRegistrationRequest,
  IsrcRegistrationRequest,
} from './model';
import {Subject} from "rxjs";
import {environment} from "../../environments/environment";
import { WhiteLabelService } from './white-label.service';



@Injectable({
  providedIn: 'root'
})
export class CartService {
  private whitelabelService = inject(WhiteLabelService);

  items: CartItem[] = [];

  cartItemsSubject:Subject<CartItem[]> = new Subject();

  constructor() {
    this.items = JSON.parse(localStorage.getItem("QUANSIC_CART") || "[]");
    this.cartItemsSubject.next(this.items);
  }

  addIsniRegistration(request:IsniRegistrationRequest){
    request._req = "isni";
    request.whitelabelId = this.whitelabelService.getWhitelabelId();
    const cartItem:CartItem = {
      id: this.generateId(),
      request: request,
      currency: 'eur'
    }
    const stripeInfo = environment.stripe.products.registrationIsni;
    cartItem.priceId = stripeInfo.price_id
    cartItem.productId = stripeInfo.product_id
    cartItem.price = stripeInfo.price
    return this.addCartItem(cartItem)
  }

  addIsrcRegistration(request:IsrcRegistrationRequest){
    request._req = "isrc";
    request.whitelabelId = this.whitelabelService.getWhitelabelId();
    const cartItem:CartItem = {
      id: this.generateId(),
      request: request,
      currency: 'eur'
    }
    const stripeInfo = environment.stripe.products.registrationIsrc;
    cartItem.priceId = stripeInfo.price_id
    cartItem.productId = stripeInfo.product_id
    cartItem.price = stripeInfo.price
    return this.addCartItem(cartItem)
  }


  generateId() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  addCartItem(line:CartItem) {
    this.items.push(line)
    this.syncCart();
    return true;
  }

  removeCartItem(id:string){
    this.items = this.items.filter((item) => item.id != id);
    this.syncCart();
  }

  resetCart(){
    this.items = [];
    this.syncCart();
  }

  syncCart(){
    this.cartItemsSubject.next(this.items);
    localStorage.setItem("QUANSIC_CART", JSON.stringify(this.items));
  }

  getCartItems(){
    return this.items;
  }

  getCartItemsObservable() {
    return this.cartItemsSubject.asObservable();
  }}
